import { FC, Fragment, useEffect, useState } from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import { FormObjSwitch } from "Utils/SwitchCases";
import CommonFormatter from "Utils/Common.Formatter";
import { FormObjType, HandleChangeType } from "DataTypes/Form";
import { ProblemForm, ICD10Form } from "./Data";
import { CommonStyle } from "Components";
import ImgPath from "Constant/Imgs";
import CstmBtn from "Components/CstmBtn";
import { DataActionType } from ".";
import DateTime from "Utils/DateTime";
import RedoxApi from "Service/Redox.api";
import { setAlertData, setFormLoader } from "Redux/Screen/Action";
import { useDispatch } from "react-redux";
import { CheckStringEmpty } from "Utils/common";
import { PatientInitialStateType } from "DataTypes/Redux";
import { useSelector } from "react-redux";

interface AddEditViewModalProps {
  onClose: () => void;
  refreshList: () => void;
  dataAction: DataActionType
}

interface Form2Type {
  id: number;
  codeId: number | null;
  code: string;
  formArr: FormObjType[]
}

const BasicForm2Data: Form2Type = {
  codeId: null,
  formArr: [...ICD10Form],
  id: 1,
  code: ""
};

const UpdateProblem: FC<AddEditViewModalProps> = (props) => {
  const dispatch = useDispatch();
  const { patientInfo }: PatientInitialStateType = useSelector(
    (state: any) => state?.patient
  );
  const { dataAction, onClose, refreshList } = props;
  const isEdit = dataAction.action == "EDIT";
  const isView = dataAction.action == "VIEW";
  const isDelete = dataAction.action == "DELETE";
  const [formData, setFormData] =
    useState<FormObjType[]>(JSON.parse(JSON.stringify(ProblemForm)));
  const [formData2, setFormData2] = useState<Form2Type[]>([]);

  useEffect(() => {
    handleLoadData();
  }, [dataAction.data?.id, dataAction.action]);

  const handleLoadData: () => void = () => {
    let newFormData: FormObjType[] = JSON.parse(JSON.stringify(ProblemForm));
    const newData = JSON.parse(JSON.stringify(dataAction?.data));
    if (isEdit || isView || isDelete) {
      newFormData = newFormData.map(formEl => {
        let inputVal = CheckStringEmpty(newData[formEl.id]);
        if (formEl.boxType == "date") {
          inputVal = DateTime.ToLocalDate(inputVal);
          if (formEl.id == "startDate") {
            formEl.maxVal = DateTime.ToLocalDate(newData?.endDate)
          }
          if (formEl.id == "endDate") {
            formEl.minVal = DateTime.ToLocalDate(newData?.startDate)
          }
        }
        return {
          ...formEl,
          inputVal,
          readOnly: isView || isDelete
        }
      })
    }
    setFormData(newFormData);
    if (dataAction.data?.altCodes && dataAction.data.altCodes.length > 0) {
      const newFormData2: Form2Type[] = [];
      dataAction.data?.altCodes.forEach((el, i) => {
        const newAltCode = JSON.parse(JSON.stringify(el));
        newFormData2.push({
          codeId: el.id,
          code: el.code,
          formArr: ICD10Form.map(formEl => {
            return {
              ...formEl,
              inputVal: CheckStringEmpty(newAltCode[formEl.id]),
              readOnly: formEl.id == "codeSystemName" ?
                true :
                isView || isDelete
            }
          }),
          id: i + 1
        })
      })
      setFormData2(newFormData2)
    } else setFormData2(JSON.parse(JSON.stringify([BasicForm2Data])));
  };

  const localHandleChange: (props: HandleChangeType) => void = (props) => {
    const { id, inputVal } = props;
    let newFormData: FormObjType[] = JSON.parse(JSON.stringify(formData));
    newFormData = newFormData.map(formEl => {
      if (id == "startDate" &&
        formEl.id == "endDate" &&
        formEl.boxType == "date") {
        formEl.minVal = CheckStringEmpty(inputVal)
      }
      if (id == "endDate" &&
        formEl.id == "startDate" &&
        formEl.boxType == "date") {
        formEl.maxVal = CheckStringEmpty(inputVal)
      }
      return {
        ...formEl
      }
    })
    setFormData(
      CommonFormatter.HandleInputChange2(props, newFormData)
    );
  }

  const localHandleChange2: (
    props: HandleChangeType, form2Obj: Form2Type
  ) => void = (props, form2Obj) => {
    const newForm2: Form2Type[] = JSON.parse(JSON.stringify(formData2));
    let newFormData: FormObjType[] = newForm2[form2Obj.id - 1].formArr
    if (props.id == "code") {
      props.inputVal = CheckStringEmpty(props.inputVal).toUpperCase()
    }
    newFormData = CommonFormatter.HandleInputChange2(props, newFormData);
    newForm2[form2Obj.id - 1].formArr = newFormData
    setFormData2(newForm2);
  }

  const handleUniqueCode: (
    formObj: Form2Type
  ) => Promise<FormObjType[]> = async (formObj) => {
    if (formObj.formArr[0].inputVal != formObj.code) {
      if (formObj.formArr[0].boxType == "input") {
        formObj.formArr[0].notUnique =
          await searchCode(CheckStringEmpty(formObj.formArr[0].inputVal));
      }
    }
    return formObj.formArr
  };

  const searchCode: (data: string) => Promise<boolean> = async (data) => {
    const res = await RedoxApi.CodeSearch({
      id1: patientInfo.id,
      data: data
    });
    if (res?.success) {
      if (res?.data) return true;
      else return false;
    } else return false;
  };

  const handleSave: () => void = async () => {
    let errorCheck = false;
    const newArr = CommonFormatter.HandleValidateForm(formData);
    if (newArr.errorCheck) errorCheck = true;
    setFormData(newArr.formData);
    dispatch(setFormLoader(true));
    const newArr2 = await Promise.all(formData2.map(async (el) => {
      const newFormArr = await handleUniqueCode(el);
      const newArr3 = CommonFormatter.HandleValidateForm(newFormArr);
      if (newArr3.errorCheck) errorCheck = true;
      el.formArr = newArr3.formData;
      return el;
    }));
    setFormData2(newArr2);
    if (!errorCheck) {
      const payload = {
        id: dataAction.data?.id || null,
        ...newArr.formData.reduce((newObj, el) => {
          let inputVal = el.inputVal;
          if (el.boxType == "date") {
            const dateVal = DateTime.ToUTCDate(inputVal);
            inputVal = (dateVal && dateVal.length) ?
              (dateVal + "T00:00:00.000Z") : "";
          }
          return {
            ...newObj,
            [el.id]: inputVal
          }
        }, {}),
        icdCodes: formData2.map(newObj => {
          return {
            id: newObj.codeId,
            name: newObj.formArr[1].inputVal,
            code: newObj.formArr[0].inputVal,
            codeSystemName: newObj.formArr[2].inputVal
          }
        })
      }
      const payload2 = {
        patientId: patientInfo.id,
        patientProblems: [payload]
      }
      const res = await RedoxApi.AddUpdateProblem({ data: payload2 });
      if (res?.success) {
        !isEdit && setFormData(JSON.parse(JSON.stringify([...ProblemForm])));
        !isEdit && setFormData2(
          JSON.parse(JSON.stringify([BasicForm2Data]))
        );
        dispatch(setAlertData(res?.alert));
        refreshList();
      }
      onClose();
    }
    dispatch(setFormLoader(false))
  };

  const handleDelete: () => void = async () => {
    dispatch(setFormLoader(true))
    const res = await RedoxApi.DeleteProblem({ id1: dataAction.data?.id });
    if (res?.success) {
      dispatch(setAlertData(res?.alert));
      refreshList();
    }
    onClose();
    dispatch(setFormLoader(false))
  };

  const handleAddAnotherCode: () => void = () => {
    setFormData2([
      ...formData2,
      {
        ...BasicForm2Data,
        id: formData2.length + 1
      }
    ])
  };

  const handleDeleteCode: (indexId: number) => void = (indexId) => {
    let newArr = formData2.filter(el => el.id != indexId);
    newArr = newArr.map((el, i) => {
      return {
        ...el,
        id: i + 1
      }
    })
    setFormData2(newArr);
  };

  return (
    <Fragment>
      <Box sx={{ ...sxHeader, ...CommonStyle.sxRow }}>
        <Typography fontWeight="bold" textTransform="capitalize">
          {dataAction.action?.toString().toLowerCase()}
          {dataAction.action == "ADD" ? "" : ` "${dataAction.data?.name}"`}
          {" Problem"}
        </Typography>
        <Box display={"flex"} alignItems={"center"}>
          <Box
            sx={{ ...CommonStyle.sxRoundIconsMainSm, mr: 1 }}
            onClick={onClose}
          >
            <ImgPath.CloseIcon titleAccess="Close" />
          </Box>
        </Box>
      </Box>
      <Box sx={{ ...sxMain }}>
        <Grid container rowSpacing={1} columnSpacing={2}>
          {formData.map((el) => {
            return (
              <Grid
                key={el.id}
                item
                {...el.id == "comment" ?
                  { md: 12, lg: 12, xl: 12 } :
                  { md: 4, lg: 4, xl: 4 }
                }
              >
                {FormObjSwitch({
                  formObj: el,
                  inputChange: async (props) => localHandleChange(props),
                  onClick: async (props) => {
                    setFormData(
                      CommonFormatter.HandleClickChange(props, formData)
                    );
                  }
                })}
              </Grid>
            );
          })}
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography variant="body2" fontWeight="bold">
          Problem Codes
        </Typography>
        {formData2.map(formEl2 => {
          return (
            <Grid key={formEl2.id} container rowSpacing={1} columnSpacing={2}>
              {formEl2.formArr.map((formEl) => {
                const showDeleteIcon = formEl.id == "codeSystemName" &&
                  formData2.length > 1
                return (
                  <Grid
                    key={formEl.id}
                    item
                    {...{ md: 4, lg: 4, xl: 4 }}
                  >
                    {showDeleteIcon ? (
                      <Box display="flex">
                        <Box width="80%">
                          {FormObjSwitch({
                            formObj: formEl,
                            inputChange: async (props) => {
                              localHandleChange2(props, formEl2)
                            },
                            onClick: async () => console.log("test")
                          })}
                        </Box>
                        <Box
                          width="20%"
                          mt={2}
                          sx={{ ...CommonStyle.sxRowCenter }}
                        >
                          <Box
                            sx={{ ...CommonStyle.sxRoundIconsMainSm }}
                            onClick={() => handleDeleteCode(formEl2.id || 0)}
                          >
                            <ImgPath.DeleteOutline />
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      FormObjSwitch({
                        formObj: formEl,
                        inputChange: async (props) => {
                          localHandleChange2(props, formEl2)
                        },
                        onClick: async () => console.log("test")
                      })
                    )}
                  </Grid>
                );
              })}
            </Grid>
          )
        })}
        <Divider sx={{ my: 2 }} />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {isDelete ?
            <Typography
              variant="body2"
              fontWeight="bold"
              letterSpacing="0.1rem"
            >
              <span style={{ color: "red" }}>Note: </span>
              This record will get
              permanently delete from the system. Are you sure?
            </Typography>
            :
            <Box></Box>
          }
          <Box
            display="flex"
            justifyContent="flex-end"
            sx={{ "&>button": { ml: 1 } }}
          >
            {isDelete && (
              <CstmBtn
                label={"Delete"}
                onClick={handleDelete}
                enableFormLoad={true}
              />
            )}
            {(!isView && !isDelete) && (
              <CstmBtn
                label={"Add Another Problem Code"}
                onClick={handleAddAnotherCode}
                enableFormLoad={true}
              />
            )}
            {(!isView && !isDelete) && (
              <CstmBtn
                label={"Save"}
                onClick={handleSave}
                enableFormLoad={true}
              />
            )}
            <CstmBtn label={"Close"} onClick={onClose} btnType="border" />
          </Box>
        </Box>
      </Box>
    </Fragment >
  );
};

export default UpdateProblem;

const sxHeader = {
  justifyContent: "space-between",
  height: "10%",
  px: 2,
};

const sxMain = {
  height: "85%",
  overflow: "auto",
  px: 2,
};
